<template>
  <router-link :to="to" class="card tool-list-card">
    <div class="tool-list-card-cover">
      <template v-if="demoImages">
        <ToolDemoCover :images="demoImages" :alt="name" />
      </template>
      <DocFormatCover
        v-else-if="isDoc"
        :tool-id="toolId"
        mode="cover"
      />
      <div v-else class="tool-list-card-fallback">
        <span class="tool-list-card-fallback-icon">{{ icon }}</span>
      </div>
      <span v-if="badge" :class="['tool-list-card-badge', badge === 'Hot' ? 'badge-hot' : 'badge-new']">{{ badge }}</span>
    </div>
    <div class="tool-list-card-body">
      <h3>{{ name }}</h3>
      <p>{{ desc }}</p>
    </div>
  </router-link>
</template>

<script>
var getToolDemoImages = require('@/config/toolDemoImages').getToolDemoImages
var isDocumentTool = require('@/config/docConvertVisuals').isDocumentTool
var DocFormatCover = require('@/components/DocFormatCover.vue').default
var ToolDemoCover = require('@/components/ToolDemoCover.vue').default

export default {
  name: 'ToolListCard',
  components: { DocFormatCover: DocFormatCover, ToolDemoCover: ToolDemoCover },
  props: {
    toolId: { type: String, required: true },
    to: { type: String, required: true },
    icon: { type: String, default: '📄' },
    badge: { type: String, default: '' }
  },
  computed: {
    demoImages: function () {
      return getToolDemoImages(this.toolId)
    },
    isDoc: function () {
      return isDocumentTool(this.toolId)
    },
    name: function () {
      return this.getToolText('name')
    },
    desc: function () {
      return this.getToolText('desc')
    }
  },
  methods: {
    getToolText: function (field) {
      var id = this.toolId
      var tools = this.$t('tools')
      if (tools && typeof tools === 'object' && tools[id] && tools[id][field]) {
        return tools[id][field]
      }
      return this.$t('tools.' + id + '.' + field)
    }
  }
}
</script>

<style scoped>
.tool-list-card {
  display: block;
  padding: 0;
  position: relative;
  height: auto;
  box-sizing: border-box;
  overflow: hidden;
  text-align: left;
  text-decoration: none;
}
.tool-list-card-cover {
  position: relative;
  display: flex;
  aspect-ratio: 16 / 9;
  background: var(--bg-secondary);
  overflow: hidden;
  transition: opacity 0.2s;
}
.tool-list-card-fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: linear-gradient(135deg, var(--bg-secondary), var(--bg-primary));
}
.tool-list-card-fallback-icon {
  font-size: 28px;
  line-height: 1;
}
.tool-list-card-badge {
  position: absolute;
  top: 6px;
  left: 6px;
  z-index: 2;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
}
.tool-list-card-body {
  padding: 10px 10px 12px;
}
.tool-list-card h3 {
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--text-primary);
}
.tool-list-card p {
  font-size: 11px;
  color: var(--text-muted);
  line-height: 1.35;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.tool-list-card:hover .tool-list-card-cover {
  opacity: 0.92;
}
</style>
